import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/Home'),
     children: [
         {
             path: '/',
             name: 'main-page',
             component: () => import('../pages/MainPage'),
         },
        {
            path: '/about-us',
            name: 'about-us',
            component: () => import('../pages/AboutUsPage'),
        },
         {
             path: '/warranties',
             name: 'warranties',
             component: () => import('../pages/WarrantiesPage'),
         },
        {
            path: '/shipping',
            name: 'shipping',
            component: () => import('../pages/ShippingPage'),
        },
        {
            path: '/best-products',
            name: 'best-products',
            component: () => import('../pages/BestProductsPage'),
        },
        {
            path: '/support',
            name: 'support',
            component: () => import('../pages/SupportPage'),
        },
        {
            path: '/categories',
            name: 'categories-page',
            component: () => import('../pages/CategoriesPage'),
        },
        {
            path: '/best-products',
            name: 'best-products',
            component: () => import('../pages/BestProductsPage'),
        },
          {
              path: '/checkout',
              name: 'checkout',
              component: () => import('../pages/Checkout'),
              },
        {
            path: '/product-page',
            name: 'product-page',
            component: () => import('../pages/ProductPage.vue')
        }
     
     ]
  },
  
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
